// Password reveal toggle — binds [data-pw-toggle] buttons to show/hide the
// password input identified by aria-controls.
export function initPasswordToggle(root) {
  var buttons = root.querySelectorAll("[data-pw-toggle]");
  buttons.forEach(function(btn) {
    if (btn.__pwToggleBound) return;
    btn.__pwToggleBound = true;
    btn.addEventListener("click", function() {
      var inputId = btn.getAttribute("aria-controls");
      var input = document.getElementById(inputId);
      if (!input) return;
      var isPassword = input.type === "password";
      input.type = isPassword ? "text" : "password";
      btn.setAttribute("aria-pressed", String(isPassword));
      btn.setAttribute("aria-label", isPassword ? "Hide password" : "Show password");
    });
  });
}
